import cx from 'classnames';
import styles from './GradientLoadingBox.scss';

const GradientLoadingBox = ({ className }) => (
  <div className={cx(styles.box, className)} />
);

export default GradientLoadingBox;
